import { render } from "./IconLiveCircle.vue?vue&type=template&id=ea51a16a"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconLiveCircle.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ea51a16a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ea51a16a', __exports__)) {
    api.reload('ea51a16a', __exports__)
  }
  
  module.hot.accept("./IconLiveCircle.vue?vue&type=template&id=ea51a16a", () => {
    api.rerender('ea51a16a', render)
  })

}


export default __exports__